import React, { useState } from "react";
import { Box } from "@mui/material";
import BroadcastNavigation from "../components/BroadcastNavigation";
import TemplatesView from "../components/TemplatesView";
import BroadcastMessagesView from "../components/BroadcastMessagesView";

const BroadcastView = () => {
  const [activeSection, setActiveSection] = useState("templates");

  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
  };

  const renderDetailView = () => {
    switch (activeSection) {
      case "templates":
        return <TemplatesView />;
      case "broadcast-messages":
        return <BroadcastMessagesView />;
      default:
        return <TemplatesView />;
    }
  };

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      {/* Left Column: Navigation Panel (25%) */}
      <Box sx={{ width: "25%", minWidth: 280 }}>
        <BroadcastNavigation
          activeSection={activeSection}
          onSectionChange={handleSectionChange}
        />
      </Box>

      {/* Right Column: Detail View (75%) */}
      <Box sx={{ flex: 1, width: "75%" }}>{renderDetailView()}</Box>
    </Box>
  );
};

export default BroadcastView;
